import { useState } from 'react';
import { adminApi } from '../api/adminClient';

export default function CompSubModal({
  memberId,
  onClose,
  onDone,
}: {
  memberId: string;
  onClose: () => void;
  onDone: () => void;
}) {
  const [plan, setPlan] = useState<'STARTER' | 'PRO' | 'PREMIUM'>('STARTER');
  const [months, setMonths] = useState(1);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    setErr(null);
    try {
      await adminApi.comp(memberId, plan, months, note || undefined);
      onDone();
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Comp suscripción</h3>
        <div className="form-control gap-2 mt-2">
          <label className="label">
            <span className="label-text">Plan</span>
          </label>
          <select
            className="select select-bordered"
            value={plan}
            onChange={(e) => setPlan(e.target.value as 'STARTER' | 'PRO' | 'PREMIUM')}
          >
            <option value="STARTER">Starter</option>
            <option value="PRO">Pro</option>
            <option value="PREMIUM">Premium</option>
          </select>
          <label className="label">
            <span className="label-text">Meses</span>
          </label>
          <input
            type="number"
            min={1}
            max={36}
            className="input input-bordered"
            value={months}
            onChange={(e) => setMonths(Number(e.target.value))}
          />
          <label className="label">
            <span className="label-text">Nota (opcional)</span>
          </label>
          <input
            className="input input-bordered"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </div>
        {err && <div className="alert alert-error mt-2">{err}</div>}
        <div className="modal-action">
          <button className="btn btn-ghost" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={submit} disabled={busy}>
            Conceder
          </button>
        </div>
      </div>
    </div>
  );
}
